export type ChatSocketRequest = {
  sessionId?: string;
  IPaddress?: string;
  message?: string;
  action?: "user_client" | "agent_client";
  channel?: "webs";
  key?: 0;
  auxAction?: AuxiliaryActions;
  isWaitMsg?: boolean;
  keepalive?: any;
};
export type liveRequest = {
  // storing for tested
  sessionId: string;
  IPaddress: string;
  message: string;
  action: "user_client" | "agent_client";
  channel: "webs";
  key: 0;
  auxAction?: AuxiliaryActions;
  isWaitMsg?: boolean;
  keepalive?: any;
};
export enum AuxiliaryActions {
  typing = "typing",
}

export enum SocketMessages {
  Connected = "Connected with user",
  Transferring = "Transferring chat to a different agent",
  Closed = "The agent closed the chat",
  UserLeft = "User has left the chat",
  ChatTasfered = "Disconnected from user",
  // ChatReleased = "Chat has been released",
  WhatsapChatTasfered = "Chat has been transferred",
  Disconnected = "Disconnected from agent",

  // AgentConnected = "Connected with user",
  // AgentTransferring = "Transferring chat to a different agent",
  // AgentClosed = "The agent closed the chat",
  // AgentUserLeft = "User has left the chat",
  // AgentChatTasfered = "Disconnected from user",
  AgentChatReleased = "Agent released the chat",
  AgentWhatsapChatTasfered = "Agent Transfer the chat to",
  AgentTakeOver = "You Taken over a conversation with the Chat bot",
  AgentStartChat = "Agent started a conversation with",
  AgentEndChat = "Agent has ended the chat",
  AgentLogout = "Transferred as the agent exit from screen",
  AgentDisconnected = "Customer disconnected from the chat",
}
export enum BanglaSocketMessages {
  Connected = "ব্যবহারকারীর সাথে সংযুক্ত",
  UserLeft = "কাস্টমার/ গ্রাহক চ্যাট শেষ করেছেন এবং চ্যাট থেকে বের হয়ে গিয়েছে",
  ChatTasfered = "থেকে সংযোগ বিচ্ছিন্ন",
}

export enum AgentMessages {
  Left = "Agent has left the chat",
  Connected = "Connected with agent",
}
export type WaitingType = {
  type: string;
  userPosition: number;
  estTime: number;
};
export enum MessageSource {
  user = "user",
  agent = "agent",
  bot = "bot",
}
export type AgentInfoType = {
  type: string;
  action: string;
  name: string;
};

export enum LiveChatMessageTypes {
  waiting = "waiting",
  agentInfo = "agent-info",
  msg = "msg",
}

export enum AgentActions {
  joined = "joined",
  left = "left",
  released = "released",
  transferred = "transferred",
}

export type MediaMetaType = {
  name?: string;
  size?: number;
  type?: string;
  mediaURL?: string;
};
